<script>
export default {
    name: "BatchDetailsPrint",

    data() {

        return {
            batchDetails: [],
        };
    },

    computed: {

        totalBillAmount() {

            if(!this.batchDetails.length) return 0;

            return this.batchDetails.map(batch => parseFloat(batch.bill_Amount))
                .reduce((sum, amt) => sum+amt);
        },

        totalPaidAmount() {

            if(!this.batchDetails.length) return 0;

            return this.batchDetails.map(batch => parseFloat(batch.paid))
                .reduce((sum, amt) => sum+amt);
        },

        totalBalanceAmount() {

            if(!this.batchDetails.length) return 0;

            return this.batchDetails.map(batch => parseFloat(batch.balance))
                .reduce((sum, amt) => sum+amt);
        },
    },

    mounted() {
        this.$root.loading = true;
        this.fetchBatchDetails().then(() => {
            this.$root.loading = false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchBatchDetails() {
            let url = `Accounts/GetOrganizationBatchedClaimsDetails`;
                url += `?BatchNo=${this.$route.query.BatchNo}`;
                url += `&OrganisationID=${this.$route.query.OrganisationID}`;
            
            return this.$http.get(url).then(response => {
                    this.batchDetails = response.data;
                }).catch(()=> {});
        },
    },
}
</script>
<template>
    <div class="flex flex-wrap w-full">
        <tail-address-header></tail-address-header>
        <div class="w-full text-center my-3">
            <h5 class="font-bold text-base uppercase">Batch Details - {{ $route.query.BatchNo }}</h5>
        </div>
        <table class="table">
            <thead class="text-sm">
                <tr>
                    <th class="p-tiny">#</th>
                    <th class="p-tiny">Organization</th>
                    <th class="p-tiny">Patient</th>
                    <th class="p-tiny">Invoice No</th>
                    <th class="p-tiny">Invoice Date</th>
                    <th class="p-tiny">Bill Amount</th>
                    <th class="p-tiny">Paid</th>
                    <th class="p-tiny">Balance</th>
                    <th class="p-tiny">Claimed</th>
                    <th class="p-tiny">Claim No</th>
                    <th class="p-tiny">Memo</th>
                    <th class="p-tiny">Notification No</th>
                    <th class="p-tiny">Posted By</th>
                    <th class="p-tiny">Batched</th>
                    <th class="p-tiny">Batch No</th>
                </tr>
            </thead>
            <tbody class="text-sm">
                <tr v-for="(claim, idx) in batchDetails" :key="idx">
                    <td class="p-tiny">{{ idx + 1 }}</td>
                    <td class="p-tiny">{{ claim.organization }}</td>
                    <td class="p-tiny">{{ claim.patient }}</td>
                    <td class="p-tiny">{{ claim.invoiceNo || `-` }}</td>
                    <td class="p-tiny">{{ claim.invoiceDate | dateFormat }}</td>
                    <td class="p-tiny">{{ claim.bill_Amount | numberFormat }}</td>
                    <td class="p-tiny">{{ claim.paid | numberFormat }}</td>
                    <td class="p-tiny">{{ claim.balance | numberFormat }}</td>
                    <td class="p-tiny">{{ claim.claimed ? `Yes` : `No` }}</td>
                    <td class="p-tiny">{{ claim.claimNo }}</td>
                    <td class="p-tiny">{{ claim.batchMemo || `-` }}</td>
                    <td class="p-tiny">{{ claim.orgnNotificationNo }}</td>
                    <td class="p-tiny">{{ claim.postedBy || `-` }}</td>
                    <td class="p-tiny">{{ claim.batched ? `Yes` :`No` }}</td>
                    <td class="p-tiny">{{ claim.batchNo }}</td>
                </tr>
                <tr class="text-base">
                    <th colspan="3" class="p-tiny"></th>
                    <th colspan="3" class="p-tiny">
                        Claims: {{ batchDetails.length }}
                    </th>
                    <th colspan="3" class="p-tiny"> 
                        Bill: {{ totalBillAmount | numberFormat }}</th>
                    <th colspan="3" class="p-tiny">
                        Paid: {{ totalPaidAmount | numberFormat }}
                    </th>
                    <th colspan="3" class="p-tiny">
                        Balance: {{ totalBalanceAmount | numberFormat }}
                    </th>
                </tr>
            </tbody>
        </table>
    </div>
</template>